import { WellnessMetrics } from './WellnessMetrics';
import { WellnessTrends } from './WellnessTrends';
import { WellnessPrePostCard } from './WellnessPrePostCard';
import { AnalyticsDashboard } from '../shared/AnalyticsDashboard';
import { WellnessFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';

interface WellnessDashboardProps {
  filters: WellnessFilter;
  className?: string;
}

export default function WellnessDashboard({ filters, className = '' }: WellnessDashboardProps) {
  return (
    <AnalyticsDashboard
      filters={filters}
      metricsComponent={WellnessMetrics}
      cards={[WellnessPrePostCard, WellnessTrends]}
      className={className}
      gridColumns={2}
      spacing="normal"
    />
  );
}
